<div class="">
  <div nz-row>
    <div nz-col [nzSpan]="24" class="header">
      <div nz-col [nzSpan]="20">
        <div class="heading">
          All Reports
        </div>
        <div>
          <label class="bold font_11">
            We’re creating new reports all the time. To suggest a report
            <a href="mailto:labssupport@visiblealpha.com">contact us</a>.
          </label>
        </div>
      </div>
      <div
        title="View list"
        (click)="showHideReportView('list')"
        class="float-right line-height-3"
        nz-col
        [nzSpan]="2"
      >
        <label class="error-icon" [ngClass]="{ selected: isListView }">
          <va-icon isFontAwesome="true" [name]="faList"></va-icon>
          List
        </label>
      </div>
      <div
        title="View grid"
        (click)="showHideReportView('grid')"
        class="float-right line-height-3"
        nz-col
        [nzSpan]="2"
      >
        <label class="error-icon" [ngClass]="{ selected: !isListView }">
          <va-icon isFontAwesome="true" [name]="faTh"></va-icon>
          Grid
        </label>
      </div>
    </div>
  </div>
  <div>
    <div class="report-section">
      <div *ngIf="isListView" class="report-list-view">
        <ng-container *ngFor="let item of filterReportList">
          <nz-divider></nz-divider>
          <div class="list-row" nz-row>
            <div nz-col [nzSpan]="8">
              <a [routerLink]="['/labs/' + item.pagename]">{{ item.name }}</a>
            </div>
            <div nz-col [nzSpan]="5">
              <label class="font_11 line_height_1">
                {{ item.group_name }}
              </label>
            </div>
            <!-- This is set visible false b'cos we don't need -->
            <div *ngIf="false" nz-col [nzSpan]="4">
              <ng-container *ngIf="item.reportcycle_name == 'Prod'">
                <div class="icon-block icon-block-ready">
                  <label class="success-icon">
                    <va-icon name="check-circle"></va-icon>
                    {{ item.report_type }}
                  </label>
                </div>
              </ng-container>
              <ng-container *ngIf="item.reportcycle_name == 'EA'">
                <div class="icon-block icon-block-testing">
                  <label class="warning-icon">
                    <va-icon [name]="faHourglassStart" [isFontAwesome]="true"></va-icon>
                    {{ item.report_type }}
                  </label>
                </div>
              </ng-container>
              <ng-container *ngIf="item.reportcycle_name == 'Labs & EA'">
                <div class="icon-block icon-block-experimental">
                  <label class="error-icon">
                    <va-icon name="exclamation-triangle"></va-icon>
                    {{ item.report_type }}
                  </label>
                </div>
              </ng-container>
              <ng-container *ngIf="item.reportcycle_name == 'Internal'">
                <div class="icon-block icon-block-internal">
                  <label class="info-icon">
                    {{ item.report_type }}
                  </label>
                </div>
              </ng-container>
            </div>
            <div nz-col [nzSpan]="11">
              <label class="font_11 line_height_1">
                {{ item.description }}
              </label>
            </div>
          </div>
        </ng-container>

        <nz-divider></nz-divider>
      </div>
      <div nz-row *ngIf="!isListView" class="report-grid-view">
        <ng-container *ngFor="let item of filterReportList">
          <div class="reportgrid-container" nz-col [nzSpan]="12">
            <div>
              <div class="reportgrid-box">
                <div class="margin_bottom_10">
                  <a [routerLink]="['/labs/' + item.pagename]">{{
                    item.name
                  }}</a>
                </div>
                <div *ngIf="false" class="margin_bottom_5">
                  <ng-container *ngIf="item.reportcycle_name == 'Prod'">
                    <div class="icon-block icon-block-ready">
                      <label class="success-icon">
                        <va-icon name="check-circle"></va-icon>
                        {{ item.report_type }}
                      </label>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="item.reportcycle_name == 'EA'">
                    <div class="icon-block icon-block-testing">
                      <label class="warning-icon">
                        <va-icon [name]="faHourglassStart" [isFontAwesome]="true"></va-icon>
                        {{ item.report_type }}
                      </label>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="item.reportcycle_name == 'Labs & EA'">
                    <div class="icon-block icon-block-experimental">
                      <label class="error-icon">
                        <va-icon name="exclamation-triangle"></va-icon>
                        {{ item.report_type }}
                      </label>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="item.reportcycle_name == 'Internal'">
                    <div class="icon-block icon-block-internal">
                      <label class="info-icon">
                        {{ item.report_type }}
                      </label>
                    </div>
                  </ng-container>
                </div>
                <div class="margin_bottom_5 reportgrid-desc">
                  <label class="font_11 line_height_1">
                    {{ item.description }}
                  </label>
                </div>
                <div>
                  <img class="reportgrid-image" [src]="item.imageURL" />
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
